module.exports = __webpack_public_path__ + "img/suggestion-private.639bfec3.png";